import React from 'react';
import { Helmet } from "react-helmet";
import { FaChartLine, FaGoogle, FaFacebookF, FaRetweet, FaBullseye, FaMicrochip } from 'react-icons/fa';
import "./PerfomanceMarketing.css";

const PerformanceMarketing = () => {
  return (
    <main className="service-page">
      <Helmet>
        <title>Performance Marketing & ROI | Skyline Bussiness Solution</title>
        <meta name="description" content="Data-driven performance marketing by Skyline Bussiness Solution at skylinebussinesssolutions.com. We optimize Google Ads, Meta Ads, and CRO to maximize your digital ROI." />
        <link rel="canonical" href="https://skylinebussinesssolutions.com/performance-marketing" />
      </Helmet>

      {/* 1. HERO SECTION */}
      <header className="service-hero">
        <div className="service-hero-content">
          <span className="service-badge">DATA-DRIVEN GROWTH</span>
          <h1 className="service-display">
            Precision <br />
            <span className="accent-text">Performance Marketing</span>
          </h1>
          <p className="service-intro">
            At <strong>Skyline Bussiness Solution</strong>, we eliminate the guesswork. 
            We engineer <strong>high-conversion ad ecosystems</strong> that turn 
            data into scalable revenue and measurable market growth.
          </p>
        </div>
      </header>

      <div className="service-container">
        
        {/* 2. THE GROWTH PILLARS */}
        <section className="strategy-section">
          <div className="strategy-card">
            <div className="strat-icon"><FaBullseye /></div>
            <h3>Predictive Targeting</h3>
            <p>Utilizing AI-driven audience modeling to find customers before they even begin their search journey.</p>
          </div>
          <div className="strategy-card">
            <div className="strat-icon"><FaMicrochip /></div>
            <h3>Algorithmic Bidding</h3>
            <p>Automation scripts that adjust your bids in real-time to ensure the lowest Cost Per Acquisition (CPA).</p>
          </div>
          <div className="strategy-card">
            <div className="strat-icon"><FaChartLine /></div>
            <h3>LTV Optimization</h3>
            <p>We don't just hunt for clicks; we optimize for Customer Lifetime Value to ensure sustainable profit.</p>
          </div>
        </section>

        {/* 3. CAPABILITIES GRID */}
        <section className="capabilities-grid">
          <div className="glass-card">
            <FaGoogle className="card-icon" />
            <h3>Search Engine Ads</h3>
            <p>Mastering Google & Bing PPC to capture high-intent traffic at the exact moment of decision.</p>
          </div>

          <div className="glass-card">
            <FaFacebookF className="card-icon" />
            <h3>Paid Social Systems</h3>
            <p>Precision-targeted campaigns across Meta, LinkedIn, and TikTok to build brand desire and demand.</p>
          </div>

          <div className="glass-card">
            <FaRetweet className="card-icon" />
            <h3>Omnichannel Retargeting</h3>
            <p>Stay top-of-mind with strategic remarketing that follows your leads across the entire digital web.</p>
          </div>
        </section>

        {/* 4. PERFORMANCE WORKFLOW */}
        <section className="workflow-section">
            <div className="section-header">
                <h2>The Growth Cycle</h2>
                <div className="line"></div>
            </div>
            <div className="workflow-steps">
                <div className="step">
                    <span>01</span>
                    <h4>Analyze</h4>
                    <p>Deep audit of your current conversion funnel and tracking pixels.</p>
                </div>
                <div className="step">
                    <span>02</span>
                    <h4>Execute</h4>
                    <p>Deploying multi-variant A/B testing across copy, creative, and landing pages.</p>
                </div>
                <div className="step">
                    <span>03</span>
                    <h4>Scale</h4>
                    <p>Aggressively pushing budget into winning variants to maximize total ROI.</p>
                </div>
            </div>
        </section>
      </div>

      {/* SCHEMA */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Performance Marketing Services",
          "provider": {
            "@type": "Organization",
            "name": "Skyline Bussiness Solution",
            "url": "https://skylinebussinesssolutions.com"
          },
          "description": "Advanced ROI-focused marketing including Google Ads, Meta Ads, and Conversion Rate Optimization."
        })}
      </script>
    </main>
  );
};

export default PerformanceMarketing;